import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";
import { BRAND } from "@/data/brand";
import { linkifyDieselPaco } from "@/components/DieselPacoText";

export default function Manifesto() {
  const { t } = useLang();
  const chapters = t.legacy.chapters;

  return (
    <section
      id="legacy"
      data-testid="legacy-section"
      className="relative bg-[#0E1F18] py-24 sm:py-32 border-t border-white/10"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="font-mono text-xs tracking-[0.25em] uppercase text-[color:var(--dp-orange)] mb-4"
            >
              {t.legacy.overline}
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="font-heading text-3xl sm:text-4xl font-black uppercase tracking-tighter text-white leading-tight"
            >
              {linkifyDieselPaco(t.legacy.title)}
            </motion.h2>
            <motion.div
              initial={{ opacity: 0, scale: 1.05 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="mt-8 overflow-hidden border border-white/10"
            >
              <img
                src={BRAND.legacyImg}
                alt="Diesel PaCo"
                className="w-full h-72 object-cover grayscale-[0.4]"
              />
            </motion.div>
          </div>

          <div className="lg:col-span-7 flex flex-col">
            {chapters.map((c, i) => (
              <motion.div
                key={c.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.05 }}
                data-testid={`chapter-${c.n}`}
                className="group grid grid-cols-[auto_1fr] gap-6 py-8 border-b border-white/10 first:border-t"
              >
                <span className="font-mono text-2xl text-white/25 group-hover:text-[color:var(--dp-orange)] transition-colors">
                  {c.n}
                </span>
                <div>
                  <h3 className="font-heading text-xl sm:text-2xl font-bold text-white mb-2">
                    {c.t}
                  </h3>
                  <p className="text-white/60 font-light leading-relaxed">{linkifyDieselPaco(c.d)}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
